import type { ReactNode } from 'react';

import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

type CustomInsightCountCardProps = {
  label: string;
  count: number;
  sublabel: string;
  icon: LucideIcon;
  className?: string;
  /** Optional trend indicator rendered under the value (compare-mode). */
  comparison?: ReactNode;
};

/**
 * Compact metric card for email / phone–number style custom insight fields (Figma: metrics row).
 */
export const CustomInsightCountCard = ({
  label,
  count,
  sublabel,
  icon: Icon,
  className,
  comparison,
}: CustomInsightCountCardProps) => {
  return (
    <div
      className={cn(
        'relative flex max-w-96 min-w-60 flex-1 items-center overflow-hidden rounded-lg border border-border bg-background p-4',
        className
      )}
    >
      <div className="flex min-w-0 flex-1 flex-col gap-4">
        <p className="text-xs leading-4 font-medium whitespace-nowrap text-muted-foreground">
          {label}
        </p>
        <div className="flex flex-col items-start justify-end gap-1">
          <div className="flex items-end gap-1.5 whitespace-nowrap">
            <span className="text-2xl leading-none font-semibold tracking-tight text-foreground">
              {count.toLocaleString()}
            </span>
            <span className="text-sm leading-none text-muted-foreground">{sublabel}</span>
          </div>
          {comparison}
        </div>
      </div>
      <div
        className="pointer-events-none absolute top-1/2 -right-[21px] size-24 -translate-y-1/2 opacity-40"
        aria-hidden
      >
        <Icon className="size-24 text-border" strokeWidth={1.5} />
      </div>
    </div>
  );
};
